module.exports = __webpack_public_path__ + "img/about-desc.3d7f3aee.png";